//no-useless-escape
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import PromiseLoadingIndicator from '../../shared/LoadingIndicator/promiseLoadingIndicator';
import LoginInputs from './loginInputs/loginInputs';
import classes from './providerEntry.module.scss';
import { Snackbar, Alert } from '@mui/material';
import dash from '../images/icon-dash.svg';
import notmet from '../images/icon-notmet.svg';
import met from '../images/icon-met.svg';
// import telekom from '../images/telekom.svg';
// import mbh from '../images/mbh.svg';
// import perfekt from '../images/perfekt.svg';
import headset from '../images/icon-headset.svg';
import logo from '../images/bookkeepie-logo.svg';
import envelop from '../images/icon-envelop.svg';

import i18n from '../../utils/i18n';
import { withTranslation } from 'react-i18next';

import { withRouter } from '../../withRouter';

//REDUX
import ACTIONS from '../../redux/action';
import { connect } from 'react-redux';

import axios from '../../shared/axios/axiosProxy';
const mapDispatchToProps = (dispatch) => ({
	addProviderInfo: (item) => dispatch(ACTIONS.addProviderInfo(item)),
	deleteItem: (id) => dispatch(ACTIONS.deleteItem(id)),
});

const mapStateToProps = (state) => ({
	provider_info: state.provider_info,
});

class Register extends React.Component {
	constructor() {
		super();

		this.state = {
			successfull: false,
			registered: false,
			password: '',
			showError: false,
			registerError: false,
			loginError: false,
			uppercaseError: false,
			lowercaseError: false,
			lengthError: false,
			numberError: false,
			showPassword: false,
			// touched: {
			// 	password: false,
			// },
			expired: false,
			errors: {
				password: '',
				checked: '',
				uppercase: false,
				lowercase: false,
				length: false,
				number: false,
			},
			checked: '',
			openSnack: false,
		};
		this.handleChange = this.handleChange.bind(this);
		this.handleBlur = this.handleBlur.bind(this);
	}

	async componentDidMount() {
		const {
			params: { JWT },
		} = this.props;
		//console.log("JWT RESET PASSWORD: ", JWT);
		try {
			const response = await axios.get('/api/auth/reset', {
				params: {
					resetPasswordToken: JWT,
				},
			});
			if (response.data.message === 'password reset link a-ok') {
				this.setState({
					email: response.data.email,
					updated: false,
					isLoading: false,
					error: false,
				});
			}
		} catch (error) {
			if (
				(error.response.data = 'password reset link is invalid or has expired')
			) {
				this.setState({
					expired: true,
				});
			}
			// if (error.response.data) console.log(error.response.data);
			this.setState({
				updated: false,
				isLoading: false,
				error: true,
			});
		}
	}

	componentDidUpdate() {
		console.log(this.state.uppercaseError, 'UPPER');
		console.log(this.state.lowercaseError, 'LOWER');
		console.log(this.state.lengthError, 'LENGTH');
		console.log(this.state.numberError, 'NUMBER');
	}

	updatePassword = async (e) => {
		e.preventDefault();
		const { email, password } = this.state;
		const {
			params: { JWT },
		} = this.props;
		try {
			const data = { email, resetPasswordToken: JWT, password };
			const response = await axios.put('/api/auth/updatePassword', {
				data,
			});
			if (response.data.message === 'password updated') {
				this.setState({
					updated: true,
					error: false,
					successfull: true,
					password: '',
				});
			} else {
				this.setState({
					updated: false,
					error: true,
				});
			}
		} catch (error) {
			if (error.response.data) console.log(error.response.data);
		}
	};
	handleClickShowPassword = () => {
		this.setState({
			showPassword: !this.state.showPassword,
		});
	};
	handleBlur(event) {
		// this.setState({
		// 	touched: { ...this.state.touched, [event.target.name]: true },
		// });
		this.validateInput(event);
	}
	handleChange(event) {
		//let field = [event.target.name];
		// if (this.state.touched[field] === true) {
		this.validateInput(event);
		// }
		this.setState({
			[event.target.name]: event.target.value,
		});
	}

	handleClose = (event, reason) => {
		this.setState({ openSnack: false });
	};
	validateInput(event) {
		const validPassword = RegExp(/^(?=.*[A-Z])+(?=.*[a-z])+(?=.*[0-9])/);
		const validUppercase = RegExp(/^(?=.*[A-Z])/);
		const validLowercase = RegExp(/^(?=.*[a-z])/);
		const validNumber = RegExp(/^(?=.*[0-9])/);
		const { name, value } = event.target;
		let errors = this.state.errors;

		switch (event.target.name) {
			case 'password':
				if (validPassword.test(value)) {
					errors.password = '';
				}
				if (!validNumber.test(value)) {
					errors.password = i18n.t('general.pwerrornumber');
					this.setState({
						numberError: true,
					});
				}
				if (!validUppercase.test(value)) {
					errors.password = i18n.t('general.pwerroruppercase');
					this.setState({
						uppercaseError: true,
					});
				}
				if (!validLowercase.test(value)) {
					errors.password = i18n.t('general.pwerrorlowercase');
					this.setState({
						lowercaseError: true,
					});
				}
				if (value.length < 8) {
					errors.password = i18n.t('general.pwerrorlength');
					this.setState({
						lengthError: true,
					});
				}
				break;
		}
		this.setState({ errors, [name]: value }, () => {});
	}
	render() {
		return (
			<>
				{this.state.expired ? (
					<div className={classes.EntryContainer}>
						<div className={classes.EntryHeader}>
							<img src={logo} alt="bookkeepie" className={classes.EntryLogo} />
							<div>
								<span className={classes.MediumText}>
									{i18n.t('general.doyouhaveanaccount')}{' '}
								</span>
								<a className={classes.noDecoration && classes.Blue14} href="/">
									{i18n.t('general.iamloggingin')}
								</a>
							</div>
						</div>
						<div className={classes.EntryFields}>
							<div>
								<div
									className={classes.EntryFieldsBox}
									style={{ minHeight: '400px', height: 'fit-content' }}>
									<img src={envelop} alt="envelop" />
									<p
										className={classes.EntryTitle}
										style={{ marginTop: '24px' }}>
										{i18n.t('general.expiredpasswordresetlink')}
									</p>
									<span span className={classes.MediumText}>
										{i18n.t('general.expiredpasswordmessage')}
									</span>

									<div
										className={classes.EntrySecondaryButton}
										style={{
											marginTop: '44px',
											backgroundColor: 'rgba(232, 234, 254, 1)',
										}}>
										<a
											className={classes.noDecoration}
											href="/provider/forgotpassword">
											{i18n.t('general.requestnewpassword')}
										</a>
									</div>
								</div>
							</div>
							<div className={classes.EntryIssueContact}>
								<img src={headset} alt="headset" />
								<span
									className={classes.SmallText}
									style={{ textDecorationLine: 'none' }}>
									{i18n.t('general.isthereaproblem')}
								</span>
								<span
									className={classes.Blue12}
									style={{ textDecorationLine: 'none' }}>
									<a
										className={classes.noDecoration}
										href="https://ie.bookkeepie.com/contact-us"
										target="_blank"
										rel="noreferrer">
										{i18n.t('general.contactus')}
									</a>
								</span>
							</div>
							{/* <div className={classes.EntryPartners}>
								<img src={telekom} alt="telekom partner" />
								<img src={mbh} alt="mbh partner" />
								<img src={perfekt} alt="perfekt partner" />
							</div> */}
						</div>
						<div className={classes.LoginBlueBox}></div>{' '}
					</div>
				) : !this.state.successfull ? (
					<div className={classes.EntryContainer}>
						<div className={classes.EntryHeader}>
							<img src={logo} alt="bookkeepie" className={classes.EntryLogo} />
							<div>
								<span className={classes.MediumText}>
									{i18n.t('general.doyouhavenotyetanaccount')}{' '}
								</span>
								{/* <span className={classes.Blue14}> */}
								<a
									className={classes.noDecoration && classes.Blue14}
									href="/provider/register">
									{i18n.t('general.iamregistering')}
								</a>
								{/* </span> */}
							</div>
						</div>
						<div className={classes.EntryFields}>
							<div className={classes.EntryFieldsBox}>
								<p className={classes.EntryTitle}>
									{i18n.t('general.settingnewpassword')}
								</p>
								<p className={classes.MediumText}>
									{i18n.t('general.providenewpwmeetscriteria')}
								</p>
								<div className={classes.providerLoginPaper}>
									<>
										<p
											style={{
												margintTop: '16px !important',
												marginBottom: '0px',
												fontSize: '14px',
												fontWeight: '500',
											}}>
											Jelszó *
										</p>
										<TextField
											type={this.state.showPassword ? 'text' : 'password'}
											name="password"
											value={this.state.password}
											onChange={this.handleChange}
											onBlur={this.handleBlur}
											error={
												this.state.errors.password.length > 0 ? true : false
											}
											InputProps={{
												endAdornment: (
													<InputAdornment position="end" tabIndex="-1">
														<IconButton
															aria-label="toggle password visibility"
															onClick={this.handleClickShowPassword}
															size="large">
															{this.state.showPassword ? (
																<Visibility />
															) : (
																<VisibilityOff />
															)}
														</IconButton>
													</InputAdornment>
												),
											}}
										/>

										<p
											style={{
												display: 'flex',
												alignItems: 'center',
												gap: '3px',
											}}>
											<img
												style={{ width: '12px' }}
												src={
													this.state.password.length < 1
														? dash
														: !this.state.lengthError
														? met
														: notmet
												}
												alt="dash"
											/>
											<span className={classes.SmallText}>
												{`${i18n.t('general.minimum')} 8 ${i18n.t(
													'general.character'
												)}`}
											</span>
										</p>
										<p
											style={{
												display: 'flex',
												alignItems: 'center',
												gap: '3px',
											}}>
											<img
												style={{ width: '12px' }}
												src={
													this.state.password.length < 1
														? dash
														: !this.state.uppercaseError
														? met
														: notmet
												}
												alt="dash"
											/>
											<span className={classes.SmallText}>
												{`${i18n.t('general.minimum')} 1 ${i18n.t(
													'general.uppercase'
												)}`}
											</span>
										</p>
										<p
											style={{
												display: 'flex',
												alignItems: 'center',
												gap: '3px',
											}}>
											<img
												style={{ width: '12px' }}
												src={
													this.state.password.length < 1
														? dash
														: !this.state.numberError
														? met
														: notmet
												}
												alt="dash"
											/>
											<span className={classes.SmallText}>
												{`${i18n.t('general.minimum')} 1 ${i18n.t(
													'general.number'
												)}`}
											</span>
										</p>
										<div style={{ marginTop: '24px' }}>
											<button
												className={classes.EntryButton}
												onClick={async (e) => {
													if (this.state.errors.password.length === 0) {
														await this.updatePassword(e);
													}
												}}>
												{i18n.t('general.savingnewpassword')}
											</button>
										</div>
									</>
								</div>
							</div>
							<div className={classes.EntryIssueContact}>
								<img src={headset} alt="headset" />
								<span
									className={classes.SmallText}
									style={{ underLine: 'none' }}>
									{i18n.t('general.isthereaproblem')}
								</span>
								<span className={classes.Blue12}>
									{i18n.t('general.contactus')}
								</span>
							</div>
							{/* <div className={classes.EntryPartners}>
								<img src={telekom} alt="telekom partner" />
								<img src={mbh} alt="mbh partner" />
								<img src={perfekt} alt="perfekt partner" />
							</div> */}
						</div>
						<div className={classes.LoginBlueBox}></div>

						<PromiseLoadingIndicator />
					</div>
				) : (
					<div className={classes.EntryContainer}>
						<Snackbar
							open={true}
							autoHideDuration={3000}
							onClose={(e) => this.handleClose(e)}>
							<Alert
								onClose={this.handleClose}
								severity="success"
								variant="filled"
								sx={{ width: '100%' }}>
								{i18n.t('general.savingpasswordsuccess')}
							</Alert>
						</Snackbar>
						<div className={classes.EntryHeader}>
							<img src={logo} alt="bookkeepie" className={classes.EntryLogo} />
							<div>
								<span className={classes.MediumText}>
									{i18n.t('general.doyouhavenotyetanaccount')}
								</span>
								{/* <span className={classes.Blue14}> */}
								<a
									className={classes.noDecoration && classes.Blue14}
									href="/provider/register">
									{i18n.t('general.iamregistering')}
								</a>
								{/* </span> */}
							</div>
						</div>
						<div className={classes.EntryFields}>
							<div className={classes.EntryFieldsBox}>
								<p className={classes.Blue10}>
									{i18n.t('general.forproviders')}
								</p>
								<p className={classes.EntryTitle}>
									{i18n.t('general.iamloggingin')}
								</p>
								<p className={classes.MediumText}>
									{i18n.t('general.providedetailsandlogin')}
								</p>
								<div className={classes.providerLoginPaper}>
									<LoginInputs />
									<div className={classes.flexCenter}>
										<span className={classes.MediumText}>
											{i18n.t('general.doyouhavenotyetanaccount')}
										</span>
										<a
											className={classes.noDecoration && classes.Blue14}
											href="/provider/register">
											{i18n.t('general.iamregistering')}
										</a>
									</div>
								</div>
							</div>
							<div className={classes.EntryIssueContact}>
								<img src={headset} alt="headset" />
								<span
									className={classes.SmallText}
									style={{ textDecorationLine: 'none' }}>
									{i18n.t('general.isthereaproblem')}
								</span>
								<span
									className={classes.Blue12}
									style={{ textDecorationLine: 'none' }}>
									<a
										className={classes.noDecoration}
										href="https://ie.bookkeepie.com/contact-us"
										target="_blank"
										rel="noreferrer">
										{i18n.t('general.contactus')}
									</a>
								</span>
							</div>
							{/* <div className={classes.EntryPartners}>
								<img src={telekom} alt="telekom partner" />
								<img src={mbh} alt="mbh partner" />
								<img src={perfekt} alt="perfekt partner" />
							</div> */}
						</div>
						<div className={classes.LoginBlueBox}></div>
					</div>
				)}
			</>
		);
	}
}

// Register.propTypes = {
// 	classes: PropTypes.object.isRequired,
// };
export default withTranslation()(
	withRouter(connect(mapStateToProps, mapDispatchToProps)(Register))
);
